import { RiskScoreDescriptionEnum } from './types';

export const RISK_SCORE_OPTIONS = Object.entries(RiskScoreDescriptionEnum).map(([key, value]) => ({
  label: value,
  value: key,
}));
